const stickyNav = {
    init() {

        // When the user scrolls the page, execute myFunction
        window.onscroll = function() {stickyness()};

        if(window.pageYOffset !== 0){
            var navbar = document.getElementById("stickyNav");
            navbar.classList.add("sticky")
        }

        // Get the navbar
        var navbar = document.getElementById("stickyNav");

        // Get the offset position of the navbar
        var sticky = navbar.offsetTop;

        // Add the sticky class to the navbar when you reach its scroll position. Remove "sticky" when you leave the scroll position
        function stickyness() {
            if (window.pageYOffset >= sticky) {
                navbar.classList.add("sticky")
                $('.menu-item').removeClass('active-sub-menu');
            } else {
                navbar.classList.remove("sticky");
            }
        }


    }
}

export {stickyNav}